import React from 'react'

const PageVideo = () => {
    return (
        <div>
            <h1>Página de Vídeos</h1>
        </div>
    )
}

export default PageVideo
